import { render, staticRenderFns } from "./mallPageDetails.vue?vue&type=template&id=b9747b20&scoped=true"
import script from "./mallPageDetails.vue?vue&type=script&lang=js"
export * from "./mallPageDetails.vue?vue&type=script&lang=js"
import style0 from "./mallPageDetails.vue?vue&type=style&index=0&id=b9747b20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9747b20",
  null
  
)

export default component.exports